module.exports = __webpack_public_path__ + "img/book1-active.044d85af.png";